import React, { createContext, useContext } from 'react';
import useProfileHook from '../hooks/useProfile';

export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const profile = useProfileHook();

  return (
    <ProfileContext.Provider value={profile}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);